/// <reference types="applepayjs" />
import { Injectable, inject } from '@angular/core';

import { PaymentEwalletTokenService } from '@payments/common-utils';
import { Subscription } from 'rxjs';

import { UrlConstants } from '../config/urlConstants';
import { DataService } from './data.service';
import { DepositService } from './deposit.service';
import { QdApiService } from './qd.service';
import { UserDataService } from './userDataService';

@Injectable({
    providedIn: 'root',
})
export class ApplePayDirectService {
    private apiService = inject(QdApiService);
    private userDataService = inject(UserDataService);
    dataService = inject(DataService);
    private depositService = inject(DepositService);

    validationURL: string;
    txnId: string;
    processorTxnID: string;
    session: ApplePaySession;
    userDataInfo: any;
    getUserDataInfo: Subscription = new Subscription();
    supportedNetworks: any = null;
    private paymentEwalletTokenService = inject(PaymentEwalletTokenService);

    getPaymentRequest(creditCardBanEnabled: string, countryCode: string, currencyCode: string, amount: string): any {
        const paymentRequest: any = {};
        paymentRequest.countryCode = countryCode;
        paymentRequest.currencyCode = currencyCode;
        paymentRequest.total = {};
        paymentRequest.total.label = '';
        paymentRequest.total.amount = amount;
        if (this.userDataService?.userData?.configParams && this.userDataService?.userData?.configParams.supportedNetworks) {
            const supportedNetworksSplit = this.userDataService?.userData?.configParams.supportedNetworks.split(',');
            paymentRequest.supportedNetworks = supportedNetworksSplit;
        } else {
            paymentRequest.supportedNetworks = ['masterCard', 'visa', 'maestro', 'amex'];
        }
        paymentRequest.merchantCapabilities = creditCardBanEnabled === 'Y' ? ['supports3DS', 'supportsDebit'] : ['supports3DS'];

        return paymentRequest;
    }

    processApplePayDeposit(depositSubmitReq: any, creditCardBanEnabled: string, countryCode: string, tokenUrl: any, cardToken?: string) {
        let paymentRequest: ApplePayJS.ApplePayPaymentRequest | undefined = undefined;
        const userData = this.userDataService?.userData;
        if ('ApplePaySession' in window && ApplePaySession.canMakePayments() === true) {
            try {
                if (this.userDataService?.userData?.configParams && this.userDataService?.userData?.configParams.supportedNetworks) {
                    const supportedNetworksSplit = this.userDataService?.userData?.configParams.supportedNetworks.split(',');
                    this.supportedNetworks = supportedNetworksSplit;
                }
                if ('Y' === creditCardBanEnabled) {
                    // eslint-disable-next-line no-console
                    console.log('Inside if ApplePayDirect');
                    paymentRequest = {
                        countryCode: countryCode,
                        currencyCode: depositSubmitReq.amountInfo.nativeCurrency,
                        total: {
                            label: userData?.configParams?.applePayLabelValue ?? '',
                            type: 'final',
                            amount: depositSubmitReq.amountInfo.nativeAmountString + '',
                        },
                        supportedNetworks: this.supportedNetworks ? this.supportedNetworks : ['masterCard', 'visa', 'maestro', 'discover'],
                        merchantCapabilities: ['supports3DS', 'supportsDebit'],
                    };
                    // eslint-disable-next-line no-console
                    console.log('ApplePayDirect Request' + JSON.stringify(paymentRequest));
                } else {
                    // eslint-disable-next-line no-console
                    console.log('Inside else ApplePayDirect');
                    paymentRequest = {
                        countryCode: countryCode,
                        currencyCode: depositSubmitReq.amountInfo.nativeCurrency,
                        total: {
                            label: userData?.configParams?.applePayLabelValue ?? '',
                            type: 'final',
                            amount: depositSubmitReq.amountInfo.nativeAmountString + '',
                        },

                        supportedNetworks:
                            this.supportedNetworks && this.supportedNetworks !== null
                                ? this.supportedNetworks
                                : ['masterCard', 'visa', 'maestro', 'amex', 'discover'],
                        merchantCapabilities: ['supports3DS'],
                    };
                    // eslint-disable-next-line no-console
                    console.log('ApplePayDirect Request' + JSON.stringify(paymentRequest));
                }

                const session = new ApplePaySession(1, paymentRequest as any);
                // eslint-disable-next-line no-console
                console.log('session ***', session);
                // defaultRemoteLogger.log(JSON.stringify(paymentRequest),'paymentRequest');
                session.onvalidatemerchant = (event) => {
                    try {
                        // eslint-disable-next-line no-console
                        console.log('Inside onvalidatemerchant');
                        // eslint-disable-next-line no-console
                        console.log('Inside onvalidatemerchant event', JSON.stringify(event));
                        // defaultRemoteLogger.log(JSON.stringify(event),'inside onvalidatemerchant');
                        this.validationURL = event.validationURL;
                        this.apiService
                            .get(
                                UrlConstants.GET_APPLEPAY_SESSION +
                                    '?validationUrl=' +
                                    this.validationURL +
                                    '&parentHostName=' +
                                    window?.location?.hostname,
                            )
                            .toPromise()
                            .then((response) => {
                                // eslint-disable-next-line no-console
                                console.log('inside response completeMerchantValidation');
                                // defaultRemoteLogger.log(JSON.stringify(event),'inside response completeMerchantValidation');
                                // eslint-disable-next-line no-console
                                console.log('onvalidatemerchant response', response);
                                session.completeMerchantValidation(response);
                                // defaultRemoteLogger.log(JSON.stringify(response),'inside response');
                            })
                            .catch((err) => {
                                // eslint-disable-next-line no-console
                                console.log('onvalidatemerchant response catch', err);
                                this.apiService
                                    .get(UrlConstants.EXCEPTION_END_URI + '?log=Exception occured in Applepay deposit Submit' + err)
                                    .subscribe(
                                        (response) => {
                                            // eslint-disable-next-line no-console
                                            console.log(response);
                                        },
                                        () => {},
                                    );
                            });
                    } catch (e) {
                        // eslint-disable-next-line no-console
                        console.log('onvalidatemerchant response catch**', e);
                        this.apiService
                            .get(
                                UrlConstants.EXCEPTION_END_URI +
                                    '?log=Exception in validate Merchant for paymentRequest' +
                                    JSON.stringify(paymentRequest) +
                                    ' with exception ' +
                                    e,
                            )
                            .subscribe(
                                (response) => {
                                    // eslint-disable-next-line no-console
                                    console.log(response);
                                },
                                () => {},
                            );
                    }
                };
                // eslint-disable-next-line no-console
                console.log('sessiononpaymentauthorized ****');
                session.onpaymentauthorized = (event) => {
                    // eslint-disable-next-line no-console
                    console.log('inside onpaymentauthorized');
                    // eslint-disable-next-line no-console
                    console.log('onpaymentauthorized event', event);
                    const payload = JSON.stringify(event.payment);
                    // defaultRemoteLogger.log(JSON.stringify(payload),'inside onpaymentauthorized');
                    // eslint-disable-next-line no-console
                    console.log('onpaymnetauth tokenurl', tokenUrl);
                    // eslint-disable-next-line no-console
                    console.log('onpaymnetauth payload', payload);
                    // eslint-disable-next-line no-console
                    console.log('onpaymnetauth cardToken', cardToken);
                    this.paymentEwalletTokenService
                        .registerCardDetails(tokenUrl, payload, cardToken)
                        .then((response: any) => {
                            // eslint-disable-next-line no-console
                            console.log('came inside' + response);
                            depositSubmitReq.paymentAccountInfo.paymentAccountId = response && response['body'] && response['body'].accounts[0].id;
                            depositSubmitReq.paymentAccountInfo.cardType = event.payment.token.paymentMethod.network;
                            depositSubmitReq.paymentAccountInfo.AccountFundingSource = event.payment.token.paymentMethod.type;
                            depositSubmitReq.paymentAccountInfo.originalCardEndDigits = event.payment.token.paymentMethod.displayName.split(' ')[1];
                            this.depositService.depositInfo.paymentAccountInfo.paymentAccountId =
                                response && response['body'] && response['body'].accounts[0].id;
                            this.depositService.depositInfo.paymentAccountInfo.cardType = event.payment?.token?.paymentMethod?.network;
                            this.depositService.depositInfo.paymentAccountInfo.AccountFundingSource = event?.payment?.token?.paymentMethod?.type;
                            this.depositService.depositInfo.paymentAccountInfo.originalCardEndDigits =
                                event?.payment?.token?.paymentMethod?.displayName?.split(' ')[1];
                            this.depositService.depositInfo.pageName = 'APPLEPAYDIRECT_input';
                            //defaultRemoteLogger.log(JSON.stringify(response),'inside registerApplepayCardDetails');
                            this.depositService.applePayDepositSubmit(depositSubmitReq).then((data: any) => {
                                if (data && data.status === 'SUCCESS') {
                                    // eslint-disable-next-line no-console
                                    console.log('inside onpaymentauthorized SUCCESS');
                                    //defaultRemoteLogger.log(JSON.stringify(data),'inside applePayDepositSubmit');
                                    session.completePayment(ApplePaySession.STATUS_SUCCESS);
                                } else {
                                    // eslint-disable-next-line no-console
                                    console.log('inside onpaymentauthorized FAILURE');
                                    session.completePayment(ApplePaySession.STATUS_FAILURE);
                                    // eslint-disable-next-line no-console
                                    console.log('inside onpaymentauthorized session abort');
                                    session.abort();
                                }
                            });
                        })
                        .catch((err: any) => {
                            session.abort();
                            this.apiService
                                .get(
                                    UrlConstants.EXCEPTION_END_URI +
                                        '?log=Exception in validate Merchant for paymentRequest' +
                                        JSON.stringify(paymentRequest) +
                                        ' with exception ' +
                                        err,
                                )
                                .subscribe(
                                    (response) => {
                                        // eslint-disable-next-line no-console
                                        console.log(response);
                                    },
                                    () => {},
                                );
                        });
                };
                // eslint-disable-next-line no-console
                console.log('session begin *** ');
                session.begin();
            } catch (e) {
                this.apiService
                    .get(
                        UrlConstants.EXCEPTION_END_URI +
                            '?log=Exception in validate Merchant for paymentRequest' +
                            JSON.stringify(paymentRequest) +
                            ' with exception ' +
                            e,
                    )
                    .subscribe(
                        (response) => {
                            // eslint-disable-next-line no-console
                            console.log(response);
                        },
                        () => {},
                    );
            }
        }
    }
}
